import { render, staticRenderFns } from "./ie11Alert.vue?vue&type=template&id=d471912e&scoped=true&"
import script from "./ie11Alert.vue?vue&type=script&lang=js&"
export * from "./ie11Alert.vue?vue&type=script&lang=js&"
import style0 from "./ie11Alert.vue?vue&type=style&index=0&id=d471912e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d471912e",
  null
  
)

export default component.exports